import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import './Blog.css';

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: 'Como identificar quando sua bateria precisa ser trocada',
      excerpt: 'Aprenda os sinais mais comuns que indicam que é hora de trocar a bateria do seu veículo.',
      image: '/Imagens/3_dobra_desk.jpg',
      date: '15 de Janeiro, 2025',
      readTime: '5 min de leitura'
    },
    {
      id: 2,
      title: 'Dicas para prolongar a vida útil da bateria',
      excerpt: 'Confira as melhores práticas para manter sua bateria funcionando por mais tempo.',
      image: '/Imagens/4_dobra_desk.jpg',
      date: '12 de Janeiro, 2025',
      readTime: '4 min de leitura'
    },
    {
      id: 3,
      title: 'Diferenças entre baterias automotivas',
      excerpt: 'Entenda as principais diferenças entre os tipos de baterias disponíveis no mercado.',
      image: '/Imagens/5_dobra_mobile.jpg',
      date: '10 de Janeiro, 2025',
      readTime: '6 min de leitura'
    }
  ];

  return (
    <section className="blog">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            Fique por dentro das novidades
          </h2>
          <p className="section-subtitle">
            Artigos e dicas para cuidar melhor do seu veículo
          </p>
        </div>
        
        <div className="blog-grid">
          {blogPosts.map((post) => (
            <article key={post.id} className="blog-card">
              <div className="blog-image">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="blog-img"
                />
              </div>
              
              <div className="blog-content">
                <div className="blog-meta">
                  <span className="blog-date">{post.date}</span>
                  <span className="blog-read-time">{post.readTime}</span>
                </div>
                
                <h3 className="blog-title">{post.title}</h3>
                <p className="blog-excerpt">{post.excerpt}</p>
                
                <a href={`#blog-${post.id}`} className="read-more">
                  Ler artigo
                  <FaArrowRight className="arrow-icon" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
